import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import enCommon from '@/core/locales/en.json';
import enAuth from '@/modules/auth/locales/en.json';
import enSubscription from '@/modules/subscription/locales/en.json';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false, // not needed for React
    },
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        subscription: enSubscription, // Load the entire subscription object, not just enSubscription.subscription
      },
    },
    defaultNS: 'common',
  });

export default i18n;
